export const toTitleCase = (str: string): string => {
  if (!str) return '';
  
  const acronyms = ['LLC', 'LLP', 'Inc', 'Ltd', 'CEO', 'CFO', 'CTO', 'VP', 'COO', 'USA', 'UK'];
  
  return str
    .toLowerCase()
    .split(/\s+/)
    .map(word => {
      if (!word) return word;
      
      const upperWord = word.toUpperCase();
      if (acronyms.includes(upperWord)) {
        return upperWord;
      }
      
      if (word.length <= 3 && word === word.toUpperCase()) {
        return word.toUpperCase();
      }
      
      if (word.includes('-')) {
        return word
          .split('-')
          .map(part => part.charAt(0).toUpperCase() + part.slice(1))
          .join('-');
      }
      
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

export const formatPhoneNumber = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '');
  
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  
  if (cleaned.length === 11 && cleaned[0] === '1') {
    return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  
  return phone;
};
